<template>
  <b-modal
    :visible="visible"
    :title="$t('page.sparks.manageTitle')"
    hide-footer
    @hide="$emit('close')"
  >
    <!-- Current Spark Balance -->
    <div class="mb-4">
      <h6 class="font-weight-bold mb-3">{{ $t("page.sparks.currentBalance") }}</h6>
      <b-row class="text-center">
        <b-col>
          <div class="spark-stat">
            <div class="spark-value text-success">{{ spark.availableSparks }}</div>
            <small class="text-muted">{{ $t("page.sparks.available") }}</small>
          </div>
        </b-col>
        <b-col>
          <div class="spark-stat">
            <div class="spark-value text-primary">{{ spark.totalSparks }}</div>
            <small class="text-muted">{{ $t("page.sparks.total") }}</small>
          </div>
        </b-col>
        <b-col>
          <div class="spark-stat">
            <div class="spark-value text-secondary">{{ spark.totalSparksUsed }}</div>
            <small class="text-muted">{{ $t("page.sparks.used") }}</small>
          </div>
        </b-col>
      </b-row>
    </div>

    <hr />

    <!-- Add Sparks -->
    <div class="mb-3">
      <h6 class="font-weight-bold mb-2">{{ $t("page.sparks.addSparks") }}</h6>
      <b-form @submit.prevent="handleAdd" class="d-flex align-items-start">
        <b-form-input
          v-model.number="addAmount"
          type="number"
          min="1"
          :placeholder="$t('page.sparks.amountPlaceholder')"
          class="mr-2"
          style="max-width: 120px"
        />
        <b-button type="submit" variant="success" :disabled="!addAmount || addAmount < 1">
          {{ $t("button.addSparks") }}
        </b-button>
      </b-form>
    </div>

    <!-- Remove Sparks -->
    <div>
      <h6 class="font-weight-bold mb-2">{{ $t("page.sparks.removeSparks") }}</h6>
      <b-form @submit.prevent="handleRemove" class="d-flex align-items-start">
        <b-form-input
          v-model.number="removeAmount"
          type="number"
          min="1"
          :max="spark.availableSparks"
          :placeholder="$t('page.sparks.amountPlaceholder')"
          class="mr-2"
          style="max-width: 120px"
        />
        <b-button
          type="submit"
          variant="danger"
          :disabled="!removeAmount || removeAmount < 1 || removeAmount > spark.availableSparks"
        >
          {{ $t("button.removeSparks") }}
        </b-button>
      </b-form>
      <small v-if="removeAmount > spark.availableSparks" class="text-danger">
        {{ $t("page.sparks.notEnoughSparks") }}
      </small>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    clientId: {
      type: String,
      required: true,
    },
    spark: {
      type: Object,
      default: () => ({ availableSparks: 0, totalSparks: 0, totalSparksUsed: 0 }),
    },
  },
  data() {
    return {
      addAmount: null,
      removeAmount: null,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.addAmount = null;
        this.removeAmount = null;
      }
    },
  },
  methods: {
    handleAdd() {
      if (!this.addAmount || this.addAmount < 1) return;
      this.$store.commit("loader/SET_LOADER", {});
      this.$store
        .dispatch("clients/addSparks", { clientId: this.clientId, amount: this.addAmount })
        .then(updatedClient => {
          this.addAmount = null;
          this.$emit("updated", updatedClient);
        })
        .catch(() => {})
        .finally(() => this.$store.dispatch("loader/close"));
    },
    handleRemove() {
      if (!this.removeAmount || this.removeAmount < 1) return;
      this.$store.commit("loader/SET_LOADER", {});
      this.$store
        .dispatch("clients/removeSparks", {
          clientId: this.clientId,
          amount: this.removeAmount,
        })
        .then(updatedClient => {
          this.removeAmount = null;
          this.$emit("updated", updatedClient);
        })
        .catch(() => {})
        .finally(() => this.$store.dispatch("loader/close"));
    },
  },
};
</script>

<style scoped>
.spark-stat {
  padding: 8px;
}
.spark-value {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.2;
}
</style>
